import hero from "../../../img/Hero/Hero.png";
import { Container } from "../../../utils/CustomComponents";
import gsap from "gsap";
import { useEffect, useRef } from "react";
function Hero() {
    const heroRef = useRef();
    useEffect(() => {
        // Basic animation for hero section
        gsap.fromTo(
            heroRef.current.children,
            { y: 50, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.125, delay: 1 }
        );
    }, []);
    return (
        <div id="hero" style={{ backgroundImage: `url(${hero})` }}>
            {/* Ref is attched to container so i can just 
        get its children straight up 
        instead of getting them one by one with multiple refs*/}
            <Container contRef={heroRef}>
                <span>welcome!</span>
                <h1>PENSION PAYMENT HAVE BEEN MADE EASIER THROUGH OUR PLATFORM.</h1>
                <div className="cta">
                    <button className="btn_pry">Get Started</button>
                </div>
            </Container>
        </div>
    );
}

export default Hero;
